'use client'

import styled, {createGlobalStyle} from 'styled-components'

import theme, {media} from '@/src/config/theme'

import Button from '@/src/shared/ui/button'
import {Label} from '@/src/shared/ui/label'
import {Link} from '@/src/shared/ui/link'
import Modal from '@/src/shared/ui/modal'

import {ProductSpoilers, ProductTabs} from './product-tabs.styled'

const sidebarWidth = 320

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;

  & h2 {
    font-size: 1.25rem;
    border: unset;
  }
`

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;

  max-width: ${theme.sizes.container}px;
`

export const ContentWrapper = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;

  & > *:first-child {
    order: 2;
  }

  @media ${media.md} {
    flex-direction: row;

    & > *:first-child {
      order: unset;
    }
  }
`

export const Gallery = styled.div``

export const Content = styled.section`
  flex: 1;

  & ${Gallery} {
    display: none;
  }

  @media ${media.md} {
    max-width: 810px;
    overflow: hidden;

    & ${Gallery} {
      display: block;
    }
  }
`

export const Sidebar = styled.section`
  flex: 1;

  & ${Gallery} {
    display: block;
  }

  @media ${media.md} {
    max-width: ${sidebarWidth}px;

    & ${Gallery} {
      display: none;
    }
  }
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 56px;
`

export const Badges = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 56px;
`

export const SaleInfo = styled.div`
  z-index: 10;

  position: absolute;

  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;

  top: 0;
  left: 0;

  padding: 6px 3px;
  background: ${theme.colors.primary};
  font-size: 1rem;
  font-weight: 400;
  border-radius: 5px;
`

export const Title = styled.h1``

export const Article = styled.span`
  font-weight: 450;
  font-size: 16px;
  color: ${theme.colors.gray};
`

export const Tabs = styled(ProductTabs)`
  margin-top: 16px;
`
export const Spoilers = styled(ProductSpoilers)`
  margin-top: 16px;
`

export const Description = styled.div`
  position: relative;
`
export const DescriptionContainer = styled.div`
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.4rem;

  * {
    white-space: normal;
  }
`

export const ShowMoreShadow = styled.div`
  z-index: 5;

  height: 60px;
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;

  background: linear-gradient(180deg, transparent 0%, rgb(255 255 255 / 75%) 100%);
`

export const ShowMore = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`
export const ShowMoreDescription = styled(Link)`
  display: flex;
  text-align: center;
  justify-content: center;
  z-index: 5;
`

export const Properties = styled.div``

export const PropertiesList = styled.div`
  gap: 5px;

  width: 100%;
  display: flex;
  flex-direction: column;
`

export const PropertySpacer = styled.span`
  flex: 1;
  border-bottom: dashed 1px ${theme.colors.gray5};
`

export const PropertyContainer = styled.div`
  width: 100%;
  max-width: 400px;
  display: flex;
`

export const PropertyName = styled.div`
  &::after {
    content: ':';
  }
`
export const PropertyValue = styled.div``

export const Prices = styled.div`
  display: flex;
  flex-direction: column;

  gap: 23px;

  margin-top: 2rem;

`
export const ProductPrice = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
  
  font-size: 1.25rem;
  line-height: 1.2;
  font-weight: 450;
  
  width: 100%;
`
export const ProductOldPrice = styled.span`
  font-size: 1.25rem;
  font-weight: 400;
  text-decoration: line-through;
  line-height: 1.2;
  color: ${theme.colors.gray3};
`
export const BuyBtn = styled(Button)``

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 5px;
`
export const FavLink = styled.div`
  padding: 10px 0;
  
  & svg {
    transition: all ease 0.3s;
  }

  & > * {
    height: 100%;
    display: flex;
    align-items: center;
    gap: 5px;
  }
`

export const ContactUs = styled.div`
  line-height: 1.4rem;
  padding: 2rem 0;
`

export const ContactUsTitle = styled.div`
  font-weight: 450;
`

export const ShipmentInfo = styled.div`
  line-height: 1.4rem;
`

export const ShipmentTitle = styled.div`
  font-weight: 450;
`

export const ServiceRecordLink = styled(Link)`
  width: 100%;
  justify-content: center;

  padding-top: 30px;
  padding-bottom: 80px;

  color: ${theme.colors.dark};
  font-size: 1.25rem;
  font-weight: 450;

  span {
    text-decoration: underline;
    text-underline-offset: 4px;
    white-space: normal;
    text-align: center;
  }
`

export const SizesModal = styled.div`
  &.ant-modal {
    width: unset !important;
    display: inline-flex;
  }

  p {
    font-size: 18px;
  }

  h2 {
    margin-bottom: 16px;
  }

  &.sizes-modal .sizes-chart {
    td {
      font-size: 18px;
      padding: 8px 12px;
    }
  }
`

export const SizesNotice = styled.div<{$maxWidth?: number}>`
  max-width: ${props => (props.$maxWidth && `${props.$maxWidth}px`) || '520px'};
  margin-bottom: 16px;
`

export const SizesLink = styled(Link)`
  padding-top: 20px;
  padding-bottom: 20px;
`

export const SizeTable = styled.div`
  table {
    display: block;
    overflow-x: auto;
  }
`

export const WarehouseAvailableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`

export const WarehouseAvailable = styled.div``

export const WarehouseLink = styled(Link)``

export const ModalForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const FeedbackModal = styled(Modal)`
  & .ant-modal-title {
    font-size: 2rem;
  }
`

export const LabelNotAvailable = styled(Label)`
  font-weight: 450;
`

export const TableStyles = createGlobalStyle`
    .sizes-modal {
      .details-popup .sizes-table-side {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        background: #000;
        color: #fff;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        padding: 17px 12px;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-flex-direction: row;
        -ms-flex-direction: row;
        flex-direction: row;
        -webkit-flex-wrap: nowrap;
        -ms-flex-wrap: nowrap;
        flex-wrap: nowrap;
        -webkit-justify-content: flex-start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        -webkit-align-content: stretch;
        -ms-flex-line-pack: stretch;
        align-content: stretch;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center
      }

      .details-popup .sizes-table-side .side-close {
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAkUlEQVR42q3T2wnAIAwFUCdxEqHQkYROVeha/eoMNkIDUnzkcQP3Qz8OaJIQqEopMaCropSbkkDeRjn5kBD4hz6Uvb104V3Ui09RKy5CtbgKleImdIW70BEOQTt4hqENXtFaBxLl52fY+v//FLL+o0a58FX3Tbh0pFR4xTQjJcK1qAi3olPci3bwyBcXak0ZfQHIKZguf/0QJgAAAABJRU5ErkJggg==) no-repeat 50% 50%
      }

      @media only screen and (-webkit-min-device-pixel-ratio: 2) {
        .details-popup .sizes-table-side .side-close {
          background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAABGklEQVR42tXZyw3CMBAE0Ej0kBZohRaA0hCfA3RBGzmlDRA5YTYoCsaY4M96d1hpDpYvT9YeMkpV/eMYY+aUM6UGNtb2ocf20yCiybSgXCirUT9g4dAD9jbYtm9PjoZ2sAfK7GNPUNA/sUjoYCwCOhqriU7GaqCzsZJoNqwEmh1bEl0MWwLtYPfsWE60GJYDLY7NQathU9Dq2Bg0DDYEDYedQsNiv6BbSgeLddCtec0RFmvtbGeBG9g27mBPqMXWh33uLGwb92Fh2/gUFg4dgoVBx2DV0SlYNXQOVhzNgRVDc2KLo0tgi6FLYtnRElg2tCQ2G+1gd5Lfs9FoTWw0GgEbjEbCetD38ZeXdXFFwjq2te9iSdlAF0aaB6/shgEREoS9AAAAAElFTkSuQmCC);
          background-size: contain
        }
      }

      .details-popup .sizes-table-side .inner {
        width: 100%;
        -webkit-order: 0;
        -ms-flex-order: 0;
        order: 0;
        -webkit-flex: 0 1 auto;
        -ms-flex: 0 1 auto;
        flex: 0 1 auto;
        -webkit-align-self: auto;
        -ms-flex-item-align: auto;
        align-self: auto
      }

      .details-popup .sizes-chart-tabs {
        position: absolute;
        left: 11px;
        width: 648px
      }

      .sizes-chart {
        width: 100%;
        white-space: nowrap
      }

      .sizes-chart th,.sizes-chart td {
        text-align: left;
        padding: 5px 7px
      }

      .sizes-chart th {
        padding-left: 0;
        font-weight: bold;
        font-size: 15px
      }

      .sizes-chart td {
        text-align: right;
        font-size: 14px
      }

      .sizes-chart tr:first-child th,.sizes-chart tr:first-child td {
        border-top: none
      }

      .sizes-chart tr:hover,.sizes-chart .highlighted {
        background: #e7e7e7
      }

      .sizes-chart-header {
        float: left
      }

      .sizes-chart-body {
        margin-left: 74px;
        overflow: hidden
      }

      @media only screen and (max-width: 480px), only screen and (max-device-width: 480px) {
        .sizes-chart-body {
          margin-left:95px
        }
      }

      @media only screen and (max-width: 480px) and (-webkit-min-device-pixel-ratio: 2), only screen and (max-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2) {
        .sizes-chart-body {
          margin-left:105px
        }
      }

      @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        .sizes-chart-body {
          margin-left:50px
        }
      }

      .sizes-chart-body .ps-scrollbar-y-rail {
        display: none
      }

      .sizes-chart-tabs .ui-tabs-nav {
        text-align: center;
        margin-bottom: 15px
      }

      .sizes-chart-tabs .ui-tabs-nav li {
        display: inline-block;
        list-style: none;
        width: 200px
      }

      @media only screen and (max-width: 480px), only screen and (max-device-width: 480px) {
        .sizes-chart-tabs .ui-tabs-nav li {
          width:100px
        }
      }

      .sizes-chart-tabs .ui-tabs-nav li a {
        display: block;
        padding: 0 15px;
        height: 29px;
        line-height: 29px;
        text-decoration: none;
        color: #fff;
        border: 1px solid #fff
      }

      .sizes-chart-tabs .ui-tabs-nav li.ui-tabs-active a {
        color: #ffcc08;
        border-color: #ffcc08
      }

      .sizes-table-popup {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        width: 1138px;
        padding: 45px 55px;
        background: #fff;
        color: #000
      }

      @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        .sizes-table-popup {
          width:1010px
        }
      }

      .sizes-table-popup .close {
        top: 30px;
        right: 30px
      }

      @media only screen and (max-width: 480px), only screen and (max-device-width: 480px) {
        .sizes-table-popup {
          -webkit-box-sizing:border-box;
          -moz-box-sizing: border-box;
          box-sizing: border-box;
          width: 100%;
          padding: 20px;
          position: fixed
        }

        .sizes-table-popup .close {
          right: 10px;
          top: 10px
        }

        .sizes-table-popup .text-container {
          display: none
        }
      }

      @media only screen and (max-width: 480px), only screen and (max-device-width: 480px) {
        .sizes-table-popup .caption {
          margin-bottom:0;
          font-size: 15px
        }
      }

      @media only screen and (max-width: 480px) and (-webkit-min-device-pixel-ratio: 2), only screen and (max-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2) {
        .sizes-table-popup .caption {
          margin-bottom:20px;
          font-size: 20px
        }
      }

      .sizes-table-popup .description {
        width: 100%
      }

      @media only screen and (max-width: 480px), only screen and (max-device-width: 480px) {
        .sizes-table-popup .description {
          margin-bottom:0
        }
      }

      .sizes-table-popup .text-container {
        max-width: 600px
      }

      .sizes-table-popup .text-container a {
        color: gray
      }

      .sizes-table-popup .text-container a:hover {
        color: #9a9a9a
      }

      .popup .ps-container {
        cursor: e-resize;
        -moz-user-select: none;
        -ms-user-select: none;
        -o-user-select: none;
        -webkit-user-select: none;
        user-select: none
      }

      .popup .ps-container.static {
        cursor: default
      }

      .popup .ps-container.static .ps-scrollbar-x-rail {
        display: none !important
      }

      .popup .ps-scrollbar-x-rail {
        position: absolute;
        bottom: 0;
        display: block;
        height: 5px !important;
        left: auto !important;
        right: 12px;
        background: #363636
      }

      .popup .ps-scrollbar-x {
        position: absolute;
        height: 5px !important;
        background: #fff
      }

      @media only screen and (max-width: 800px) {
        .size-choice-popup {
          padding:0 10px
        }
      }
      
      td.highlight {
        background: #e7e7e7;
      }
      
      .sizes-chart {
        padding-top: 5px;
      }
    }
  
`
